import React from 'react';

type Props = {
  fields?: string[] | null;
  className?: string;
};

export default function ListingUnknownBadges({ fields, className = '' }: Props) {
  if (!fields?.length) return null;
  return (
    <span className={`listing-unknown-badges ${className}`.trim()}>
      {fields.map((label) => (
        <span key={label} className="badge badge-muted" title={label}>
          {label}
        </span>
      ))}
    </span>
  );
}
